import { CheckIcon, XIcon } from "lucide-react";
import type { FC, RefObject } from "react";
import { StressPattern } from "@/components/stress-pattern";
import { cn } from "@/lib/cn";

export const StressOption: FC<{
  index: number;
  syllableCount: number;
  isCorrectAnswer: boolean;
  isSelected: boolean;
  isCorrect: boolean;
  hasAnswered: boolean;
  disabled: boolean;
  highlight: boolean;
  itemRef?: RefObject<HTMLButtonElement | null>;
  onClick: () => void;
}> = (props) => {
  const showCorrectMark = props.hasAnswered && props.isCorrectAnswer;
  const showWrongMark =
    props.hasAnswered && props.isSelected && !props.isCorrect;

  return (
    <button
      ref={props.itemRef}
      type="button"
      disabled={props.disabled}
      onClick={props.onClick}
      className={cn(
        "flex min-w-24 flex-col items-center gap-2 rounded-lg border-2 border-muted-foreground/30 px-5 py-3 transition-all duration-300",
        !props.hasAnswered && !props.disabled && "hover:bg-muted",
        showCorrectMark && "border-success bg-success-muted",
        showWrongMark && "border-destructive bg-destructive/10",
        props.hasAnswered &&
          !props.isCorrectAnswer &&
          !props.isSelected &&
          "opacity-40",
        props.highlight &&
          "border-foreground bg-background text-foreground ring-1 ring-foreground/35",
      )}
    >
      <StressPattern
        syllableCount={props.syllableCount}
        stressIndex={props.index}
      />
      <div
        className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full",
          showCorrectMark && "bg-success text-primary-foreground",
          showWrongMark && "bg-destructive text-primary-foreground",
          !showCorrectMark && !showWrongMark && "invisible",
        )}
      >
        {showCorrectMark && <CheckIcon className="h-4 w-4" />}
        {showWrongMark && <XIcon className="h-4 w-4" />}
      </div>
    </button>
  );
};
